import React from 'react';
import { useVeliOgrenci } from '../../context/VeliOgrenciContext';

export default function VeliOgrenciSecici() {
  const { ogrenciler, seciliOgrenci, setSeciliOgrenci, birdenFazla } = useVeliOgrenci();

  // 1 öğrencisi var ise hiçbir şey değişmeyecek, kartlar görünmeyecek
  if (!birdenFazla || !ogrenciler || ogrenciler.length <= 1) {
    return null;
  }

  return (
    <div style={{
      background: 'var(--card-bg, #ffffff)',
      border: '1px solid var(--border-color, #e2e8f0)',
      borderRadius: 16,
      padding: '16px 18px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 8,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: '1.25rem' }}>👨‍👩‍👧‍👦</span>
          <div>
            <div style={{
              fontWeight: 800,
              fontSize: '0.92rem',
              color: 'var(--text-primary, #0f172a)',
              letterSpacing: '-0.01em',
            }}>
              Öğrenci Seçimi ({ogrenciler.length} Öğrenciniz Kayıtlı)
            </div>
            <div style={{ fontSize: '0.75rem', color: 'var(--text-muted, #64748b)' }}>
              Bilgilerini ve raporlarını görüntülemek istediğiniz öğrencinizi seçin
            </div>
          </div>
        </div>

        {seciliOgrenci && (
          <span style={{
            fontSize: '0.75rem',
            fontWeight: 700,
            color: 'var(--accent, #6366f1)',
            background: 'var(--accent-dim, rgba(99,102,241,0.12))',
            padding: '4px 10px',
            borderRadius: 999,
          }}>
            Şu an: <b>{seciliOgrenci.ad} {seciliOgrenci.soyad}</b>
          </span>
        )}
      </div>

      {/* Öğrenci Kartları */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: 12,
      }}>
        {ogrenciler.map((ogr) => {
          const isSelected = String(seciliOgrenci?.id) === String(ogr.id);
          const initials = `${(ogr.ad || '')[0] || ''}${(ogr.soyad || '')[0] || ''}`.toUpperCase();

          return (
            <div
              key={ogr.id}
              onClick={() => setSeciliOgrenci(ogr)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '12px 14px',
                borderRadius: 14,
                cursor: 'pointer',
                border: isSelected
                  ? '2px solid var(--accent, #6366f1)'
                  : '1.5px solid var(--border-color, #e2e8f0)',
                background: isSelected
                  ? 'var(--accent-dim, rgba(99, 102, 241, 0.08))'
                  : 'var(--card-bg, #ffffff)',
                boxShadow: isSelected
                  ? '0 6px 20px rgba(99, 102, 241, 0.18)'
                  : '0 2px 8px rgba(0, 0, 0, 0.03)',
                transition: 'all 0.18s ease',
                position: 'relative',
                overflow: 'hidden',
              }}
            >
              {/* Avatar */}
              <div style={{
                width: 42,
                height: 42,
                borderRadius: '50%',
                background: isSelected
                  ? 'linear-gradient(135deg, var(--accent, #6366f1), #4338ca)'
                  : 'var(--bg-subtle, #f1f5f9)',
                color: isSelected ? '#ffffff' : 'var(--text-muted, #64748b)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 800,
                fontSize: '0.9rem',
                flexShrink: 0,
              }}>
                {initials || 'Ö'}
              </div>

              {/* Bilgiler */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{
                  fontWeight: 800,
                  fontSize: '0.9rem',
                  color: isSelected ? 'var(--accent, #6366f1)' : 'var(--text-primary, #0f172a)',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}>
                  {ogr.ad} {ogr.soyad}
                </div>
                <div style={{
                  fontSize: '0.74rem',
                  color: 'var(--text-muted, #64748b)',
                  marginTop: 2,
                  display: 'flex',
                  gap: 6,
                  alignItems: 'center',
                  flexWrap: 'wrap',
                }}>
                  {ogr.sinif_adi && (
                    <span style={{ fontWeight: 600, color: 'var(--text-secondary, #334155)' }}>
                      {ogr.sinif_adi}
                    </span>
                  )}
                  {ogr.ogrenci_no && (
                    <span>• No: {ogr.ogrenci_no}</span>
                  )}
                </div>
              </div>

              {/* Seçili Rozeti */}
              {isSelected ? (
                <span style={{
                  fontSize: '0.7rem',
                  fontWeight: 800,
                  color: '#10b981',
                  background: 'rgba(16, 185, 129, 0.12)',
                  padding: '3px 8px',
                  borderRadius: 999,
                  flexShrink: 0,
                }}>
                  ✓ Seçili
                </span>
              ) : (
                <span style={{
                  fontSize: '0.68rem',
                  fontWeight: 600,
                  color: 'var(--text-muted, #94a3b8)',
                  flexShrink: 0,
                }}>
                  Seç →
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
